import { request } from './repository';

const url = 'source-service-priorities/';


const sourceServicePriorityRepository = {
    getSourceServicePriorities() {
        return request.get(url);
    }
}

export default sourceServicePriorityRepository;
